import { Injectable } from "@angular/core";

/**
 * Tracks template-bound overlays (e.g. ion-modal [isOpen]) that are not
 * created via ModalController and therefore invisible to ModalQueueService.
 */
@Injectable({ providedIn: "root" })
export class ModalOverlayCoordinationService {
  private openOverlays = new Set<string>();

  setOverlayOpen(id: string, open: boolean): void {
    open ? this.openOverlays.add(id) : this.openOverlays.delete(id);
  }

  hasOpenOverlay(): boolean {
    return this.openOverlays.size > 0;
  }

  setLocationActivationModalOpen(open: boolean): void {
    this.setOverlayOpen("location-activation", open);
  }

  isLocationActivationModalOpen(): boolean {
    return this.openOverlays.has("location-activation");
  }
}
